import React from 'react'
import { Popover } from '@headlessui/react'
import { HiOutlineChevronDown } from 'react-icons/hi'
const DropDownList = ({ title = '', children }) => {
  return (
    <>
      <Popover>
        {({ open }) => (
          <>
            <Popover.Button
              className={`${
                open
                  ? 'leading-4 flex justify-between bg-black py-3 px-4 relative z-[100] outline-none h-16 text-sm border border-custom-gray-80 border-b-0 tagline-font'
                  : 'text-opacity-90 border border-custom-gray-80'
              } leading-4 flex justify-between bg-black py-3 lg:py-[10px] pl-5 w-full text-xs lg:text-sm tagline-font`}
            >
              <span>{title}</span>
              <HiOutlineChevronDown
                className={`${
                  open ? 'rotate-180 transform mr-0' : ''
                } h-4 w-4 mr-4 text-white transition duration-150 ease-in-out group-hover:text-opacity-80`}
                aria-hidden="true"
              />
            </Popover.Button>
            {children}
          </>
        )}
      </Popover>
    </>
  )
}

export default DropDownList
